import angular from 'angular';

export const SettingsControllerModule = angular
  .module('acme.view.application.settings.controllers', [])
  .controller('SettingsController', [
    '$scope',
    function ($scope) {
      const ctrl = {
        model: 'Your spankin new application.settings.default view!',

        init: function () {},

        success: {
          init: function (response) {},
        },

        error: {
          init: function (response) {},
        },
      };

      $scope.settings = ctrl;
      ctrl.init();
    },
  ]).name;
